import { render, staticRenderFns } from "./invitationModel.vue?vue&type=template&id=a468e5fe&scoped=true&lang=pug&"
import script from "./invitationModel.vue?vue&type=script&lang=js&"
export * from "./invitationModel.vue?vue&type=script&lang=js&"
import style0 from "./invitationModel.vue?vue&type=style&index=0&id=a468e5fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a468e5fe",
  null
  
)

export default component.exports